// file imports *****************************************************************************

import React from "react";
import { ROUTES } from "../config/app-constants";
import { ProtectedRoutes } from "./ProtectedRoutes"; //authorization
import { Routes as Switch, Route } from "react-router-dom";

//Component imports *************************************************************************

import Signup from "../pages/login/Signup";
// import { Userpilot } from "userpilot";
import Agents from "../pages/agents/Agents";
import { Login } from "../pages/login/Login";
import Privacy from "../pages/privacy/Privacy";
import OTPLogin from "../pages/login/OTPLogin";
import Metrics from "../pages/metrics/Metrics";
import Teams from "../pages/settings/Teams/Teams";
import Settings from "../pages/settings/Settings";
import MyCalendar from "../pages/calendar/Calendar";
import EditAgents from "../pages/agents/EditAgents";
import ErrorLogs from "../pages/errorLogs/ErrorLogs";
import Import from "../pages/settings/Import/Import";
import Dashboard from "../pages/dashboard/Dashboard";
import Templates from "../pages/templates/Templates";
import PageNotFound from "../common/alert/PageNotFound";
import ResetPassword from "../pages/login/ResetPassword";
import Inspections from "../pages/inspection/Inspections";
import Payments from "../pages/settings/Payments/Payments";
import ForgotPassword from "../pages/login/ForgotPassword";
import CreatePassword from "../pages/login/CreatePassword";
import PaymentMade from "../pages/notifications/PaymentMade";
import TeamDetails from "../pages/settings/Teams/TeamDetails";
import MyProfile from "../pages/settings/MyProfile/MyProfile";
import TemplateEditor from "../pages/templates/TemplateEditor";
import Notifications from "../pages/notifications/Notifications";
import PaymentRequest from "../pages/notifications/PaymentRequest";
import ServicesPage from "../pages/settings/Services/ServicesPage";
import PTCompanyList from "../pages/PTAdmin/Company/PTCompanyList";
import ImportTemplate from "../pages/importTemplate/ImportTemplate";
import BillingPlan from "../pages/settings/BillingPlan/BiliingPlan";
import SignatureNeeded from "../pages/notifications/SignatureNeeded";
import PaymentReminder from "../pages/notifications/PaymentReminder";
import AgreementToSign from "../pages/notifications/AgreementToSign";
import MapFullView from "../components/InspectionDetails/MapFullView";
import PaymentSignature from "../pages/notifications/PaymentSignature";
import ChangePassword from "../pages/settings/MyProfile/ChangePassword";
import AgreementsList from "../pages/settings/Agreements/AgreementsList";
import PTCompanyDetails from "../pages/PTAdmin/Company/PTCompanyDetails";
import RequestPayment from "../components/requestPayment/RequestPayment";
import RejectAgreement from "../pages/settings/Agreements/RejectAgreement";
import AcceptAgreement from "../pages/settings/Agreements/AcceptAgreement";
import CompanyProfile from "../pages/settings/CompanyProfile/CompanyProfile";
import AgreementInvalid from "../pages/settings/Agreements/AgreementInvalid";
import AgreementWebView from "../pages/settings/Agreements/AgreementWebView";
import ReportSettings from "../pages/settings/ReportSettings/ReportSettings";
import InspectionDetails from "../pages/inspectionDetails/InspectionDetails";
import InspectionsPublished from "../pages/notifications/InspectionsPublished";
import AgreementsDetails from "../pages/settings/Agreements/AgreementsDetails";
import ScheduleInspection from "../pages/scheduleInspection/ScheduleInspection";
import RescheduleConfirmation from "../pages/notifications/RescheduleConfirmation";
import PtSupportProfile from "../pages/settings/PTSupportProfile/PtSupportProfile";
import AppointmentConfirmation from "../pages/notifications/AppointmentConfirmation";
import AgreementAlreadySigned from "../pages/settings/Agreements/AgreementAlreadySigned";
import AgreementSignedConfirmation from "../pages/notifications/AgreementSignedConfirmation";
import InspectorServiceGroup from "../pages/settings/InspectorServiceGroup/InspectorServiceGroup";
import { useEffect } from "react";
import ErrorDetailedView from "../pages/errorLogs/ErrorDetailedView";
import PtImport from "../pages/PTAdmin/Import/PtImport";
import PtTemplates from "../pages/PTAdmin/PtTemplates/PtTemplates";
import PtTemplateDetails from "../components/PTadmin/PtTemplate/PtTemplateDetails";
import CommentLibrary from "../pages/commentLibrary/CommentLibrary";
import { setIsHTCompany } from "../store/action";
import { useDispatch } from "react-redux";
import BookingPage from "../online-scheduler/pages/BookingPage";
import ConfigurationPage from "../online-scheduler/pages/ConfigurationPage";

const setStorageItem = (storage, key, value) => {
  try {
    storage.setItem(key, value);
  } catch {
    // ignore blocked storage access
  }
};

// ----------------------------------------------------------------------------------------------------------
const Router = (props) => {
  const { companyInfo, } = props;
  const path = window.location.pathname || "";
  const schedulerPathIndex = path.indexOf("/online-scheduler");
  const hasSchedulerRedirect = schedulerPathIndex !== -1;

  const dispatch = useDispatch();
  // PALM 10151
  // const location = useLocation();
  // useEffect(() => {
  //   Userpilot.reload();
  // }, [location]);

  useEffect(() => {
    dispatch(setIsHTCompany(companyInfo?.is_ht_company));
  }, [companyInfo, dispatch]);

  useEffect(() => {
    if (!hasSchedulerRedirect) return;

    const company = path.substring(0, schedulerPathIndex).replace(/^\//, "");
    const token = path.substring(schedulerPathIndex + "/online-scheduler".length).replace(/^\//, "");

    if (company) setStorageItem(sessionStorage, "company_name", company);
    if (token) setStorageItem(sessionStorage, "company_key", token);
    // Fallback for Mobile Safari where sessionStorage may be unavailable
    if (token) setStorageItem(localStorage, "scheduler_company_key", token);
    if (company) setStorageItem(localStorage, "scheduler_company_name", company);

    window.location.replace("/#/online-scheduler");
  }, [hasSchedulerRedirect, path, schedulerPathIndex]);

  if (hasSchedulerRedirect) return null;


  return (
    <>
      <Switch>
        {/* public routes ****************************************************************************/}
        <Route path={ROUTES.HOME} exact element={<Login />} />
        <Route path={ROUTES.SIGNUP} exact element={<Signup />} />
        <Route path={ROUTES.RESET} exact element={<ResetPassword />} />
        <Route path={ROUTES.MAP_VIEW} exact element={<MapFullView />} />
        <Route path={ROUTES.CREATE} exact element={<CreatePassword />} />
        <Route path={ROUTES.FORGOT} exact element={<ForgotPassword />} />
        <Route path={ROUTES.VIEW_AGREEMENT} exact element={<AgreementWebView />} />
        <Route path={ROUTES.ACCEPT_AGREEMENT} exact element={<AcceptAgreement />} />
        <Route path={ROUTES.REQUEST_PAYMENT} exact element={<RequestPayment />} />
        <Route path={ROUTES.REJECT_AGREEMENT} exact element={<RejectAgreement />} />
        <Route path={ROUTES.AGREEMENT_ALREADY_SIGNED} exact element={<AgreementAlreadySigned />} />
        <Route path={ROUTES.AGREEMENT_INVALID} exact element={<AgreementInvalid />} />
        <Route path={ROUTES.REPORT_SETTINGS} exact element={<ProtectedRoutes route={<ReportSettings />} />} />
        <Route path={ROUTES.PRIVACY_CONTENT} exact element={<Privacy />} />
        <Route path={ROUTES.OTP_LOGIN} exact element={<OTPLogin />} />
        <Route path={ROUTES.ONLINE_SCHEDULER} element={<BookingPage />} />
        <Route path={ROUTES.ONLINE_SCHEDULER_CONFIG} exact element={<ProtectedRoutes route={<ConfigurationPage />} />} />
        <Route path={ROUTES.FALLBACK} exact element={<PageNotFound type="404" message="Page not found" action="Redirect" />} />
        {/* protected routes************************************************************************* */}
        <Route path={ROUTES.AGENT_SCREEN} exact element={<ProtectedRoutes route={<Agents />} />} />
        <Route path={ROUTES.COMMENT_LIBRARY} exact element={<ProtectedRoutes route={<CommentLibrary />} />} />
        <Route path={ROUTES.DASHBOARD_SCREEN} exact element={<ProtectedRoutes route={<Dashboard />} />} />
        <Route path={ROUTES.TEAMS} exact element={<ProtectedRoutes route={<Teams />} />} />
        <Route path={ROUTES.BILLING_PLAN} exact element={<ProtectedRoutes route={<BillingPlan />} />} />
        <Route path={ROUTES.MY_PROFILE} exact element={<ProtectedRoutes route={<MyProfile />} />} />
        <Route path={ROUTES.CHANGE} exact element={<ProtectedRoutes route={<ChangePassword />} />} />
        <Route path={ROUTES.TEMPLATES} exact element={<ProtectedRoutes route={<Templates />} />} />
        <Route path={ROUTES.EDIT_AGENT} exact element={<ProtectedRoutes route={<EditAgents />} />} />
        <Route path={ROUTES.EDIT_TEMPLATE} exact element={<ProtectedRoutes route={<TemplateEditor />} />} />
        <Route path={ROUTES.METRICS_SCREEN} exact element={<ProtectedRoutes route={<Metrics />} />} />
        <Route path={ROUTES.CALENDER_SCREEN} exact element={<ProtectedRoutes route={<MyCalendar />} />} />
        <Route path={ROUTES.TEAMS_DETAILS} exact element={<ProtectedRoutes route={<TeamDetails />} />} />
        <Route path={ROUTES.SERVICES} exact element={<ProtectedRoutes route={<ServicesPage />} />} />
        <Route path={ROUTES.INSPECTION_LISTING} exact element={<ProtectedRoutes route={<Inspections />} />} />
        <Route path={ROUTES.NOTIFICATION_MENU} exact element={<ProtectedRoutes route={<Notifications />} />} />
        <Route path={ROUTES.APPOINTMENT_CONFIRMATION} exact element={<ProtectedRoutes route={<AppointmentConfirmation />} />} />
        <Route path={ROUTES.RESCHEDULE_CONFIRMATION} exact element={<ProtectedRoutes route={<RescheduleConfirmation />} />} />
        <Route path={ROUTES.SIGNATURE_NEEDED} exact element={<ProtectedRoutes route={<SignatureNeeded />} />} />
        <Route path={ROUTES.AGREEMENT_TO_SIGN} exact element={<ProtectedRoutes route={<AgreementToSign />} />} />
        <Route path={ROUTES.AGREEMENT_SIGNED_CONFIRMATION} exact element={<ProtectedRoutes route={<AgreementSignedConfirmation />} />} />
        <Route path={ROUTES.PAYMENT_MADE} exact element={<ProtectedRoutes route={<PaymentMade />} />} />
        <Route path={ROUTES.PAYMENT_REQUEST} exact element={<ProtectedRoutes route={<PaymentRequest />} />} />
        <Route path={ROUTES.PAYMENT_SIGNATURE} exact element={<ProtectedRoutes route={<PaymentSignature />} />} />
        <Route path={ROUTES.PAYMENT_REMINDER} exact element={<ProtectedRoutes route={<PaymentReminder />} />} />
        <Route path={ROUTES.INSPECTION_PUBLISHED} exact element={<ProtectedRoutes route={<InspectionsPublished />} />} />
        <Route path={ROUTES.INSPECTION_DETAILS} exact element={<ProtectedRoutes route={<InspectionDetails />} />} />
        <Route path={ROUTES.SCHEDULE_INSPECTION} exact element={<ProtectedRoutes route={<ScheduleInspection />} />} />
        <Route path={ROUTES.COMPANY_PROFILE} exact element={<ProtectedRoutes route={<CompanyProfile />} />} />
        <Route path={ROUTES.AGREEMENTS} exact element={<ProtectedRoutes route={<AgreementsList />} />} />
        <Route path={ROUTES.AGREEMENTS_DETAILS} exact element={<ProtectedRoutes route={<AgreementsDetails />} />} />
        <Route path={ROUTES.SETTINGS} exact element={<ProtectedRoutes route={<Settings />} />} />
        <Route path={ROUTES.PAYMENTS} exact element={<ProtectedRoutes route={<Payments />} />} />
        <Route path={ROUTES.IMPORT} exact element={<ProtectedRoutes route={<Import />} />} />
        <Route path={ROUTES.INSPECTOR_SERVICE_GROUP} exact element={<ProtectedRoutes route={<InspectorServiceGroup />} />} />
        <Route path={ROUTES.ERROR_LOGS} exact element={<ProtectedRoutes route={<ErrorLogs />} />} />
        <Route path={ROUTES.ERROR_DETAILED_VIEW} exact element={<ProtectedRoutes route={<ErrorDetailedView />} />} />
        <Route path={ROUTES.IMPORT_DATA_V9} exact element={<ProtectedRoutes route={<ImportTemplate />} />} />
        {/* PT Admin pages ============================================================================== */}
        <Route path={ROUTES.PT_COMPANY} exact element={<ProtectedRoutes route={<PTCompanyList />} />} />
        <Route path={ROUTES.PT_COMPANY_DETAILS} exact element={<ProtectedRoutes route={<PTCompanyDetails />} />} />
        <Route path={ROUTES.PT_TEAMS} exact element={<ProtectedRoutes route={<Teams />} />} />
        <Route path={ROUTES.PT_TEAMS_DETAILS} exact element={<ProtectedRoutes route={<TeamDetails />} />} />
        <Route path={ROUTES.PT_SUPPORT_PROFILE} exact element={<ProtectedRoutes route={<PtSupportProfile />} />} />
        <Route path={ROUTES.PT_IMPORT} exact element={<ProtectedRoutes route={<PtImport />} />} />
        <Route path={ROUTES.PT_TEMPLATE} exact element={<ProtectedRoutes route={<PtTemplates />} />} />
        <Route path={ROUTES.PT_TEMPLATE_DETAILS} exact element={<ProtectedRoutes route={<PtTemplateDetails />} />} />
      </Switch>
    </>
  );
};

export default Router;
